import BasePerimeter from './basePerimeter';

export default new BasePerimeter({
  purpose: 'users',
  govern: {
    'can route': function route() {
      return this.isAdmin();
    },
    'can createUser': function createUser() {
      return this.isAdmin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/perimeters/usersPerimeter.js